
import { GrantTypeLabel, AdvertiserAccountType, GrantType, PlanType } from '@/common/permission';
import _ from 'lodash';

export default {
  props: {
    authorizeInfo: {
      type: Object,
      default: function _default() {
        return {};
      }
    },

    formValue: {
      type: Object,
      required: true
    },

    action: {
      type: String,
      default: 'create'
    }
  },
  data: function data() {
    return {
      GrantType: GrantType,
      GrantTypeLabel: GrantTypeLabel,
      options: [],
      planTitle: '无'
    };
  },

  watch: {
    'formValue.mws_account_type': function formValueMws_account_type(val) {
      if (val) {
        this.getGrantTypeLabel();

        if (val === AdvertiserAccountType.Internal) {
          // eslint-disable-next-line vue/no-mutating-props
          this.formValue.grant_type = GrantType.Internal;
        }

        if (val === AdvertiserAccountType.Normal && this.formValue.grant_type === GrantType.Internal) {
          // eslint-disable-next-line vue/no-mutating-props
          this.formValue.grant_type = GrantType.Normal;
        }
      }
    },
    'formValue.adv_id': function formValueAdv_id() {
      // this.getAdvPrimaryPlanInfo()
      this.advPrimaryPlanTitle();
    },
    'authorizeInfo.id': function authorizeInfoId() {
      this.advPrimaryPlanTitle();
    }
  },
  methods: {
    getGrantTypeLabel: function getGrantTypeLabel() {
      var _this = this;

      this.options = _.map(GrantTypeLabel, function (v, k) {
        k = Number(k);
        return {
          label: v,
          value: k,
          disabled: _this.formValue.mws_account_type === AdvertiserAccountType.Normal && k === GrantType.Internal || _this.formValue.mws_account_type === AdvertiserAccountType.Internal && k !== GrantType.Internal
        };
      });
    },
    advPrimaryPlanTitle: function advPrimaryPlanTitle() {
      if (_.isEmpty(this.authorizeInfo) || this.formValue.grant_type !== GrantType.Trial) {
        this.planTitle = '无';

        return;
      }

      this.planTitle = this.authorizeInfo.plan_name + '/' + this.authorizeInfo.expired_time;
    },
    handleInput: function handleInput() {
      // eslint-disable-next-line vue/no-mutating-props
      this.formValue.plan_id = '';
      // eslint-disable-next-line vue/no-mutating-props
      this.formValue.permissions = '';
      // eslint-disable-next-line vue/no-mutating-props
      this.formValue.reset_day = '';
      // eslint-disable-next-line vue/no-mutating-props
      this.formValue.render_video = '';
      // eslint-disable-next-line vue/no-mutating-props
      this.formValue.mtg_charge = '';
      // eslint-disable-next-line vue/no-mutating-props
      this.formValue.download_push = '';
      // eslint-disable-next-line vue/no-mutating-props
      this.formValue.isEdit = false;
      // eslint-disable-next-line vue/no-mutating-props
      this.formValue.days = '';
      // eslint-disable-next-line vue/no-mutating-props
      this.formValue.revenue = '';
      // eslint-disable-next-line vue/no-mutating-props
      this.formValue.online = '';
      // eslint-disable-next-line vue/no-mutating-props
      this.formValue.type = PlanType.Subscription;

      // this.getAdvPrimaryPlanInfo()
      this.advPrimaryPlanTitle();
    }
  },
  created: function created() {
    this.getGrantTypeLabel();
  }
};